import React from 'react';
import styles from './css/SelectElement.css';

export const SelectElement = ({ options = [], value, onChange, name }) => (
  <select value={value} onChange={onChange} id={name} className={styles.select}>
    {options.map(({ label, value }) => <option key={value} value={value}>{label}</option>)}
  </select>
);